/**
 * The "Issues & alerts" notices on the BOM analysis page, derived only from
 * what the analysis actually measured: how many parts and distributors it
 * covered and how many part-distributor pairs have no offer. The analysis
 * carries no lifecycle (obsolete / NRND) or price-history data, so nothing
 * here may claim either.
 *
 * tone: "danger" | "info" | "success"
 */
export const analysisNotices = ({ partCount, distributorCount, unavailablePairs }) => {
  if (!(partCount > 0) || !(distributorCount > 0)) {
    return [
      {
        tone: "info",
        title: "Nothing to analyse yet",
        detail: "Connect a distributor and search or upload a BOM to see coverage here.",
      },
    ];
  }
  if (unavailablePairs > 0) {
    return [
      {
        tone: "danger",
        title: `${unavailablePairs} part-distributor pairs unavailable`,
        detail: "Consider alternates or wait for restock.",
      },
    ];
  }
  return [
    {
      tone: "success",
      title: "Every part has an offer from every distributor",
      detail: "Coverage only; lifecycle status is not part of this analysis.",
    },
  ];
};
